import axios from 'axios';

export const malimaxThreeApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/malimax-three`,
    headers: {
        'Content-Type': 'application/json'
    }
})